import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    padding: 24px;
    margin-top: 24px;
    border-radius: 10px;
    border: 1px solid ${theme.colors.background.hover};
    background: ${theme.colors.lightest};
    box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover};
    display: flex;
    flex-direction: column;
    gap: 16px;
  `}
`

export const Label = styled(Box)`
  ${({ theme }) => css`
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${theme.colors.secondary};
  `}
`

export const Content = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: column;
      align-items: stretch;
    }
  `}
`

export const MetricBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IconBox = styled(Box)`
  ${({ theme }) => css`
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.green.light};
    background: ${theme.colors.green.background};
  `}
`

export const MetricTexts = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const MetricLabel = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: -0.32px;
    color: ${theme.colors.secondary};
  `}
`

export const MetricValues = styled(Box)`
  display: flex;
  align-items: baseline;
  gap: 12px;
`

export const PercentageValue = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: -0.32px;
    color: ${theme.colors.secondary};
  `}
`

export const Value = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.32px;
    color: ${theme.colors.secondary};
  `}
`
